import React, { useEffect, useState } from 'react';
import {
    Grid,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Checkbox,
    Button,
    TextField,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useUser } from '../contexts/UserContext';
import Autocomplete from '@mui/material/Autocomplete';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function PerfilAcceso() {
    const server = process.env.REACT_APP_API_ROUTE;
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [perfiles, setPerfiles] = useState([]);
    const [perfilSeleccionado, setPerfilSeleccionado] = useState('');

    const [accesos, setAccesos] = useState([]);
    const [accesosAsignados, setAccesosAsignados] = useState({});
    const [accesosOriginales, setAccesosOriginales] = useState({});
    const [accesosPerfilData, setAccesosPerfilData] = useState([]);

    const [permisos, setPermisos] = useState([]);
    const [permisosAsignados, setPermisosAsignados] = useState({});
    const [permisosOriginales, setPermisosOriginales] = useState({});
    const [permisosPerfilData, setPermisosPerfilData] = useState([]);

    const [menus, setMenus] = useState([]);
    const [searchAcceso, setSearchAcceso] = useState('');
    const [searchPermiso, setSearchPermiso] = useState('');

    useEffect(() => {
        fetch(`${server}/sg_perfile`)
            .then(r => r.json())
            .then(d => setPerfiles(d.$values || []));

        fetch(`${server}/sg_acceso`)
            .then(r => r.json())
            .then(d => setAccesos(d.$values || []));

        fetch(`${server}/SgPermisos`)
            .then(r => r.json())
            .then(d => {
                const lista = d.$values || d || [];
                setPermisos(lista);
            });

        fetch(`${server}/sg_menu`)
            .then(r => r.json())
            .then(d => setMenus(d.$values || []));
    }, []);

    useEffect(() => {
        if (!perfilSeleccionado) return;

        // Accesos
        fetch(`${server}/sg_accesos_perfil/${perfilSeleccionado}`)
            .then(r => {
                if (!r.ok) throw new Error('Error al obtener accesos');
                return r.json();
            })
            .then(d => {
                const valores = d?.$values || [];
                setAccesosPerfilData(valores);
                const asignados = valores.reduce((acc, a) => {
                    const idAcc = a.idacceso || a.idAcceso || a.id_acceso || a.id;
                    return { ...acc, [idAcc.toString()]: true };
                }, {});
                setAccesosAsignados(asignados);
                setAccesosOriginales(asignados);
            })
            .catch(err => {
                console.warn("Accesos no encontrados o error:", err.message);
                setAccesosAsignados({});
                setAccesosOriginales({});
            });

        // Permisos
        fetch(`${server}/SgPermisosPerfil/perfilpermisos/${perfilSeleccionado}`)
            .then(r => {
                if (!r.ok) throw new Error('Error al obtener permisos');
                return r.json();
            })
            .then(d => {
                const valores = d?.$values || [];
                setPermisosPerfilData(valores);
                const asignados = valores.reduce((acc, p) => ({ ...acc, [p.id_permiso]: true }), {});
                setPermisosAsignados(asignados);
                setPermisosOriginales(asignados);
            })
            .catch(err => {
                console.warn("Permisos no encontrados o error:", err.message);
                setPermisosPerfilData([]);
                setPermisosAsignados({});
                setPermisosOriginales({});
            });

    }, [perfilSeleccionado]);

    const toggleAsignacion = (setter, id, currentState) => {
        setter(prev => ({ ...prev, [id]: !currentState }));
    };

    // Obtener el id_menu de un acceso
    const getMenuIdFromAcceso = (acceso) => acceso?.id_menu || acceso?.idMenu || 0;

    // Obtener nombre del menú
    const getMenuNombre = (idMenu) => {
        if (!idMenu || idMenu === 0) return 'Sin menú';
        const menu = menus.find(m => m.id === idMenu);
        return menu ? menu.nombre_menu : `Menú #${idMenu}`;
    };

    // Permisos de un acceso específico (por id_menu del acceso)
    const getPermisosByAcceso = (acceso) => {
        const idMenu = getMenuIdFromAcceso(acceso);
        if (!idMenu) return [];
        return permisos.filter(p => (p.id_menu || p.idMenu) === idMenu);
    };

    // Contar permisos asignados de un acceso
    const countPermisosAsignados = (acceso) => {
        const permisosDelAcceso = getPermisosByAcceso(acceso);
        return permisosDelAcceso.filter(p => !!permisosAsignados[p.id_permiso || p.idPermiso]).length;
    };

    // Toggle todos los permisos de un acceso
    const toggleTodosPermisosAcceso = (acceso, value) => {
        const permisosDelAcceso = getPermisosByAcceso(acceso);
        setPermisosAsignados(prev => {
            const updated = { ...prev };
            permisosDelAcceso.forEach(p => {
                const id = p.id_permiso || p.idPermiso;
                updated[id] = value;
            });
            return updated;
        });
    };

    const handleGuardar = async () => {
        const fecha = new Date().toISOString().slice(0, 19);
        const usuario = (user?.codigoUsuario || 'ADMIN').substring(0, 20).padEnd(20);
        const operaciones = [];

        // Accesos
        Object.entries(accesosAsignados).forEach(([id, asignado]) => {
            const eraAsignado = !!accesosOriginales[id.toString()];
            const Acceso = {
                idAcceso: parseInt(id),
                idPerfil: perfilSeleccionado,
                IngresadoPor: usuario,
                fechaIngreso: fecha
            };
            if (asignado && !eraAsignado) {
                operaciones.push(fetch(`${server}/sg_accesos_perfil`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(Acceso)
                }));
            } else if (!asignado && eraAsignado) {
                const registro = accesosPerfilData.find(ap => String(ap.id) === String(id));
                const idPk = registro?.idAccesoPerfil || registro?.id_acceso_perfil || registro?.id;
                operaciones.push(fetch(`${server}/sg_accesos_perfil/${id}/${perfilSeleccionado}/${encodeURIComponent(usuario)}`, {
                    method: 'DELETE'
                }));
            }
        });

        // Permisos
        Object.entries(permisosAsignados).forEach(([id_permiso, asignado]) => {
            const eraAsignado = !!permisosOriginales[id_permiso];
            const Permiso = {
                id_permiso: parseInt(id_permiso),
                id_perfil: perfilSeleccionado,
                IngresadoPor: usuario,
                fechaIngreso: fecha
            };
            if (asignado && !eraAsignado) {
                operaciones.push(fetch(`${server}/SgPermisosPerfil`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(Permiso)
                }));
            } else if (!asignado && eraAsignado) {
                const registro = permisosPerfilData.find(pp => String(pp.id_permiso) === String(id_permiso));
                const idPk = registro?.id_permiso_perfil || registro?.idPermisoPerfil;
                if (idPk) {
                    operaciones.push(fetch(`${server}/SgPermisosPerfil/${idPk}/${encodeURIComponent(usuario)}`, {
                        method: 'DELETE'
                    }));
                }
            }
        });

        await Promise.all(operaciones);
        Swal.fire('Éxito', 'Cambios guardados correctamente', 'success');
    };

    // Filtrar accesos según búsqueda
    const accesosFiltrados = accesos.filter(a =>
        a.nombreacceso?.toLowerCase().includes(searchAcceso.toLowerCase())
    );

    // Accesos que tienen permisos asociados Y están activos (checked)
    const accesosConPermisos = accesosFiltrados.filter(a =>
        getPermisosByAcceso(a).length > 0 && !!accesosAsignados[a.id.toString()]
    );
    const accesosSinPermisos = accesosFiltrados.filter(a => getPermisosByAcceso(a).length === 0);

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    <Grid container spacing={3}>
                        {/* Selección de perfil */}
                        <Grid item xs={12}>
                            <Typography variant="h5" gutterBottom>Asignación de Accesos y Permisos por Perfil</Typography>
                            <Autocomplete
                                options={perfiles}
                                getOptionLabel={(option) => option.nombreperfil || ''}
                                value={perfiles.find(p => p.id === perfilSeleccionado) || null}
                                onChange={(e, newValue) => {
                                    setPerfilSeleccionado(newValue ? newValue.id : '');
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Seleccionar Perfil" variant="outlined" fullWidth />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        </Grid>

                        {/* Panel izquierdo: Accesos con checkboxes */}
                        <Grid item xs={12} md={5}>
                            <Typography variant="h6" gutterBottom>Accesos</Typography>
                            <TextField
                                fullWidth
                                placeholder="Buscar acceso..."
                                value={searchAcceso}
                                onChange={(e) => setSearchAcceso(e.target.value)}
                                sx={{ mb: 1 }}
                                size="small"
                            />
                            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Acceso</TableCell>
                                            <TableCell align="center">
                                                <Checkbox
                                                    checked={accesosFiltrados.length > 0 && accesosFiltrados.every(a => !!accesosAsignados[a.id.toString()])}
                                                    indeterminate={accesosFiltrados.some(a => !!accesosAsignados[a.id.toString()]) && !accesosFiltrados.every(a => !!accesosAsignados[a.id.toString()])}
                                                    onChange={(e) => {
                                                        const todos = accesosFiltrados.every(a => !!accesosAsignados[a.id.toString()]);
                                                        setAccesosAsignados(prev => {
                                                            const updated = { ...prev };
                                                            accesosFiltrados.forEach(a => { updated[a.id.toString()] = !todos; });
                                                            return updated;
                                                        });
                                                    }}
                                                    size="small"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {accesosFiltrados.map(a => (
                                            <TableRow key={a.id}>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        {a.nombreacceso}
                                                        {getPermisosByAcceso(a).length > 0 && (
                                                            <Chip
                                                                label={`${countPermisosAsignados(a)}/${getPermisosByAcceso(a).length}`}
                                                                size="small"
                                                                color={countPermisosAsignados(a) > 0 ? "success" : "default"}
                                                                variant="outlined"
                                                            />
                                                        )}
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Checkbox
                                                        checked={!!accesosAsignados[a.id.toString()]}
                                                        onChange={() => {
                                                            const current = !!accesosAsignados[a.id.toString()];
                                                            toggleAsignacion(setAccesosAsignados, a.id.toString(), current);
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        {/* Panel derecho: Permisos agrupados por acceso */}
                        <Grid item xs={12} md={7}>
                            <Typography variant="h6" gutterBottom>Permisos Especiales por Acceso</Typography>
                            <TextField
                                fullWidth
                                placeholder="Buscar permiso..."
                                value={searchPermiso}
                                onChange={(e) => setSearchPermiso(e.target.value)}
                                sx={{ mb: 1 }}
                                size="small"
                            />

                            <Box sx={{ maxHeight: 500, overflow: 'auto' }}>
                                {accesosConPermisos.length > 0 && (() => {
                                    const todosPermisosVisibles = accesosConPermisos.flatMap(a =>
                                        getPermisosByAcceso(a).filter(p =>
                                            !searchPermiso || p.permiso?.toLowerCase().includes(searchPermiso.toLowerCase())
                                        )
                                    );
                                    const todosCheck = todosPermisosVisibles.length > 0 && todosPermisosVisibles.every(p => !!permisosAsignados[p.id_permiso || p.idPermiso]);
                                    const algunoCheck = todosPermisosVisibles.some(p => !!permisosAsignados[p.id_permiso || p.idPermiso]);
                                    return (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, px: 1 }}>
                                            <Checkbox
                                                checked={todosCheck}
                                                indeterminate={algunoCheck && !todosCheck}
                                                onChange={() => {
                                                    setPermisosAsignados(prev => {
                                                        const updated = { ...prev };
                                                        todosPermisosVisibles.forEach(p => {
                                                            updated[p.id_permiso || p.idPermiso] = !todosCheck;
                                                        });
                                                        return updated;
                                                    });
                                                }}
                                                size="small"
                                            />
                                            <Typography variant="body2" fontWeight="bold">
                                                Seleccionar todos los permisos
                                            </Typography>
                                        </Box>
                                    );
                                })()}

                                {accesosConPermisos.length === 0 && (
                                    <Typography variant="body2" color="textSecondary" sx={{ p: 2 }}>
                                        No hay permisos especiales definidos para los accesos disponibles.
                                    </Typography>
                                )}

                                {accesosConPermisos.map(acceso => {
                                    const permisosDelAcceso = getPermisosByAcceso(acceso).filter(p =>
                                        !searchPermiso || p.permiso?.toLowerCase().includes(searchPermiso.toLowerCase())
                                    );
                                    if (permisosDelAcceso.length === 0) return null;

                                    const todosAsignados = permisosDelAcceso.every(p => !!permisosAsignados[p.id_permiso || p.idPermiso]);
                                    const algunoAsignado = permisosDelAcceso.some(p => !!permisosAsignados[p.id_permiso || p.idPermiso]);

                                    return (
                                        <Accordion key={acceso.id} defaultExpanded={false}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                                    <Checkbox
                                                        checked={todosAsignados}
                                                        indeterminate={algunoAsignado && !todosAsignados}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            toggleTodosPermisosAcceso(acceso, !todosAsignados);
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                        size="small"
                                                    />
                                                    <Typography variant="subtitle2" fontWeight="bold">
                                                        {acceso.nombreacceso}
                                                    </Typography>
                                                    <Chip
                                                        label={`${countPermisosAsignados(acceso)}/${permisosDelAcceso.length}`}
                                                        size="small"
                                                        color={todosAsignados ? "success" : algunoAsignado ? "warning" : "default"}
                                                    />
                                                </Box>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ p: 0 }}>
                                                <Table size="small">
                                                    <TableBody>
                                                        {permisosDelAcceso.map(p => {
                                                            const idP = p.id_permiso || p.idPermiso;
                                                            return (
                                                                <TableRow key={idP}>
                                                                    <TableCell sx={{ pl: 4 }}>{p.permiso}</TableCell>
                                                                    <TableCell align="center" sx={{ width: 60 }}>
                                                                        <Checkbox
                                                                            checked={!!permisosAsignados[idP]}
                                                                            onChange={() => {
                                                                                const current = !!permisosAsignados[idP];
                                                                                toggleAsignacion(setPermisosAsignados, idP, current);
                                                                            }}
                                                                            size="small"
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </AccordionDetails>
                                        </Accordion>
                                    );
                                })}
                            </Box>
                        </Grid>

                        {/* Botones de acción */}
                        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
                            <Button variant="contained" color="primary" onClick={handleGuardar}>
                                Guardar Cambios
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={() => {
                                setAccesosAsignados(accesosOriginales);
                                setPermisosAsignados(permisosOriginales);
                            }}>
                                Cancelar Cambios
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    );
}

export default PerfilAcceso;
